module.exports = __webpack_public_path__ + "static/img/tian-guan-jin.194e96b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/tian-guan-jin.jpeg
// module id = VXoR
// module chunks = 1